export enum RouteLink {
    ANY = '*',
    INDEX = '/',
    ERROR = '/error',
    LOGIN_COACHEE = '/coachee/login',
    VERIFY_PASSWORD_COACHEE = '/coachee/verify-password',
    OKTA_LOGIN_COACHEE = '/coachee/auth/okta/sso',
    AUTH_PROVIDOR_LOGIN_COACHEE = '/coachee/auth/sama/sso',
}
